<!-- <script>
import { menuItems } from "~/components/layouts/utils/menu-cms.js";
import MetisMenu from "metismenujs";

export default {
  data() {
    return {
      menuItems
    };
  },
  props: {
    type: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true
    }
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar");
              document.body.removeAttribute("data-sidebar-size");
              break;
            case "light":
              document.body.setAttribute("data-sidebar", "light");
              document.body.removeAttribute("data-sidebar-size");
              document.body.classList.remove("vertical-collpsed");
              break;
            case "compact":
              document.body.setAttribute("data-sidebar-size", "small");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "icon":
              document.body.setAttribute("data-keep-enlarged", "true");
              document.body.classList.add("vertical-collpsed");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "colored":
              document.body.setAttribute("data-sidebar", "colored");
              document.body.removeAttribute("data-keep-enlarged");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-sidebar-size");
              break;
            default:
              document.body.setAttribute("data-sidebar", "dark");
              break;
          }
        }
      }
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      }
    }
  },
  mounted() {
    const element = document.getElementById("side-menu");
    if (element) {
      new MetisMenu("#side-menu");
      this._activateMenuDropdown();

      this.$router.afterEach((routeTo, routeFrom) => {
        this._activateMenuDropdown();
      });
    }
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    /**
     * remove active and mm-active class
     */
    _removeAllClass(className) {
      const els = document.getElementsByClassName(className);
      while (els[0]) {
        els[0].classList.remove(className);
      }
    },
    _activateMenuDropdown() {
      this._removeAllClass("mm-active");
      this._removeAllClass("mm-show");

      var links = document.getElementsByClassName("side-nav-link-ref");
      var matchingMenuItem = null;
      const paths = [];

      for (var i = 0; i < links.length; i++) {
        paths.push(links[i]["pathname"]);
      }
      var itemIndex = paths.indexOf(window.location.pathname);
      if (itemIndex === -1) {
        const strIndex = window.location.pathname.lastIndexOf("/");
        const item = window.location.pathname.substr(0, strIndex).toString();
        matchingMenuItem = links[paths.indexOf(item)];
      } else {
        matchingMenuItem = links[itemIndex];
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add("active");
        var parent = matchingMenuItem.parentElement;

        /**
         * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
         * We should come up with non hard coded approach
         */
        if (parent) {
          parent.classList.add("mm-active");
          const parent2 = parent.parentElement.closest("ul");
          if (parent2 && parent2.id !== "side-menu") {
            parent2.classList.add("mm-show");

            const parent3 = parent2.parentElement;
            if (parent3) {
              parent3.classList.add("mm-active");
              var childAnchor = parent3.querySelector(".has-arrow");
              var childDropdown = parent3.querySelector(".has-dropdown");
              if (childAnchor) childAnchor.classList.add("mm-active");
              if (childDropdown) childDropdown.classList.add("mm-active");

              const parent4 = parent3.parentElement;
              if (parent4 && parent4.id !== "side-menu") {
                parent4.classList.add("mm-show");
                const parent5 = parent4.parentElement;
                if (parent5 && parent5.id !== "side-menu") {
                  parent5.classList.add("mm-active");
                  const childanchor = parent5.querySelector(".is-parent");
                  if (childanchor && parent5.id !== "side-menu") {
                    childanchor.classList.add("mm-active");
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};
</script> -->

<template>
     
  <div class="vertical-menu">

      <div class="navbar-brand-box">
        <nuxt-link to="/" class="logo d-grid">
                   <span class="logo-cont">
                     <img class="logo-sm-h" src="/images/pijace.png" width="40" alt="cene na pijacama" /> 
                   </span>        
        </nuxt-link>
    </div>

    <button type="button" 
           @click="toggleMenu"
             aria-label="Otvori meni"
            class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn">
      <i class="esei icon-bars"></i>
    </button>

    <div data-simplebar class="sidebar-menu-scroll">
      <div id="sidebar-menu">
            <!-- Left Menu Start -->
            <ul class="metismenu list-unstyled" id="side-menu">
                <template v-for="item in menuItems">
                    <li class="menu-title" v-if="item.isTitle" :key="item.id">{{ item.label }}</li>
                    <li v-if="!item.isTitle && !item.isLayout" :key="item.id">
                    <!-- meni koji ima podmeni hasItems - provera podmanija -->
                       <a v-if="hasItems(item)" href="javascript:void(0);" class="is-parent" :class="{
                  'has-arrow': !item.badge,
                  'has-dropdown': item.badge
                }">
                            <i :class="`${item.icon}`" v-if="item.icon"></i>
                            <span>{{ item.label }}</span>
                            <span :class="
                    `badge badge-pill bg-${item.badge.variant} float-end`
                  " v-if="item.badge">{{ item.badge.text }}</span>
                        </a>
                       <!-- meni koji nema podmeni hasItems - provera podmanija -->
                        <nuxt-link :to="item.link" v-if="!hasItems(item) && !item.logout" class="side-nav-link-ref">
                            <i :class="`${item.icon}`" v-if="item.icon"></i>
                            <span>{{ item.label }}</span>
                            <!-- <span :class="
                    `badge badge-pill badge-${item.badge.variant} float-end`
                  " v-if="item.badge">{{ item.badge.text }}</span> -->
                        </nuxt-link>
                      
                        <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
                            <li v-for="(subitem, index) of item.subItems" :key="index">
                                <nuxt-link :to="subitem.link" v-if="!hasItems(subitem)" :class="`side-nav-link-ref  ${subitem.class ? subitem.class : ''}`">{{ subitem.label }}</nuxt-link>
                                <a v-if="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);">{{ subitem.label }}</a>
                                <ul v-if="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                                    <li v-for="(subSubitem, index) of subitem.subItems" :key="index">
                                        <nuxt-link :to="subSubitem.link" class="side-nav-link-ref">{{ subSubitem.label }}</nuxt-link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <div  v-if="!hasItems(item) && item.logout" class="side-nav-link-ref logout-sider bg-danger mt-1"
                                >
                            <i :class="`${item.icon}`" v-if="item.icon"></i>
                            <span class="ms-2">{{ item.label }}</span>
                        </div>
                    </li>
                </template>
            </ul>
        </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, watch} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { menuItems } from '~/components/layouts/utils/menu-cms.js'
import MetisMenu from 'metismenujs'

// Props
const props = defineProps({
  type: {
    type: String,
    required: true
  },
  width: {
    type: String,
    required: true
  }
})
const emit = defineEmits(['toggleMenu'])

// Router
const route = useRoute()
const router = useRouter()

// Menu podaci
const items = menuItems

// Metode
const toggleMenu = () => {

  // zameni sa emit ako koristiš parent emitovanje
  emit('toggleMenu')
}

const hasItems = (item) => {
  return item.subItems?.length > 0
}

const _removeAllClass = (className) => {
  const els = document.getElementsByClassName(className)
  while (els[0]) {
    els[0].classList.remove(className)
  }
}

const _activateMenuDropdown = () => {
  _removeAllClass('mm-active')
  _removeAllClass('mm-show')

  const links = document.getElementsByClassName('side-nav-link-ref')
  let matchingMenuItem = null
  const paths = Array.from(links).map(link => link.pathname)

  const itemIndex = paths.indexOf(window.location.pathname)
  if (itemIndex === -1) {
    const strIndex = window.location.pathname.lastIndexOf('/')
    const item = window.location.pathname.substring(0, strIndex)
    matchingMenuItem = links[paths.indexOf(item)]
  } else {
    matchingMenuItem = links[itemIndex]
  }

  if (matchingMenuItem) {
    matchingMenuItem.classList.add('active')
    let parent = matchingMenuItem.parentElement

    if (parent) {
      parent.classList.add('mm-active')
      const parent2 = parent.parentElement.closest('ul')
      if (parent2 && parent2.id !== 'side-menu') {
        parent2.classList.add('mm-show')

        const parent3 = parent2.parentElement
        if (parent3) {
          parent3.classList.add('mm-active')
          const childAnchor = parent3.querySelector('.has-arrow')
          const childDropdown = parent3.querySelector('.has-dropdown')
          if (childAnchor) childAnchor.classList.add('mm-active')
          if (childDropdown) childDropdown.classList.add('mm-active')

          const parent4 = parent3.parentElement
          if (parent4 && parent4.id !== 'side-menu') {
            parent4.classList.add('mm-show')
            const parent5 = parent4.parentElement
            if (parent5 && parent5.id !== 'side-menu') {
              parent5.classList.add('mm-active')
              const childanchor = parent5.querySelector('.is-parent')
              if (childanchor && parent5.id !== 'side-menu') {
                childanchor.classList.add('mm-active')
              }
            }
          }
        }
      }
    }
  }
}

// Reagovanje na promene propova
watch(
  () => props.type,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      switch (newVal) {
        case 'dark':
          document.body.setAttribute('data-sidebar', 'dark')
          document.body.removeAttribute('data-topbar')
          document.body.removeAttribute('data-sidebar-size')
          break
        case 'light':
          document.body.setAttribute('data-sidebar', 'light')
          document.body.removeAttribute('data-sidebar-size')
          document.body.classList.remove('vertical-collpsed')
          break
        case 'compact':
          document.body.setAttribute('data-sidebar-size', 'small')
          document.body.setAttribute('data-sidebar', 'dark')
          document.body.classList.remove('vertical-collpsed')
          document.body.removeAttribute('data-topbar')
          break
        case 'icon':
          document.body.setAttribute('data-keep-enlarged', 'true')
          document.body.classList.add('vertical-collpsed')
          document.body.setAttribute('data-sidebar', 'dark')
          document.body.removeAttribute('data-topbar')
          break
        case 'colored':
          document.body.setAttribute('data-sidebar', 'colored')
          document.body.removeAttribute('data-keep-enlarged')
          document.body.classList.remove('vertical-collpsed')
          document.body.removeAttribute('data-sidebar-size')
          break
        default:
          document.body.setAttribute('data-sidebar', 'dark')
      }
    }
  },
  { immediate: true }
)

watch(
  () => props.width,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      switch (newVal) {
        case 'boxed':
          document.body.setAttribute('data-layout-size', 'boxed')
          break
        case 'fluid':
          document.body.setAttribute('data-layout-mode', 'fluid')
          document.body.removeAttribute('data-layout-size')
          break
        default:
          document.body.setAttribute('data-layout-mode', 'fluid')
      }
    }
  },
  { immediate: true }
)

// Inicijalizacija meni sistema
onMounted(() => {
  const element = document.getElementById('side-menu')
  if (element) {
    new MetisMenu('#side-menu')
    _activateMenuDropdown()
    router.afterEach(() => {
      _activateMenuDropdown()
    })
  }
})
</script>

